"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("@emotion/react");
const icons_1 = require("../icons");
const icon_button_styles_1 = require("./icon_button.styles");
const label_1 = __importDefault(require("../typography/label"));
function passthroughEventHandler(callback, passthroughFn) {
    return (e) => {
        callback(e);
        if (passthroughFn) {
            passthroughFn(e);
        }
    };
}
const IconButton = (_a) => {
    var { iconName, label, hoverFill, fill, slashcolor, disabledFillOverride, size, iconSize = null, onMouseEnter, onMouseLeave, disabled, buttonRef, fillLevel } = _a, buttonProps = __rest(_a, ["iconName", "label", "hoverFill", "fill", "slashcolor", "disabledFillOverride", "size", "iconSize", "onMouseEnter", "onMouseLeave", "disabled", "buttonRef", "fillLevel"]);
    const theme = (0, react_2.useTheme)();
    const [hovered, setHovered] = (0, react_1.useState)(false);
    const color = hovered && hoverFill ? hoverFill : fill ? fill : theme.colors.grey90;
    return ((0, jsx_runtime_1.jsxs)(icon_button_styles_1.Button, Object.assign({ "data-testid": iconName + '-icon-button', ref: buttonRef, onMouseEnter: passthroughEventHandler(() => setHovered(true), onMouseEnter), onMouseLeave: passthroughEventHandler(() => setHovered(false), onMouseLeave), size: size, disabled: disabled, type: "button" }, buttonProps, { children: [(0, jsx_runtime_1.jsx)(label_1.default, Object.assign({ screenReaderOnly: true }, { children: label })), (0, jsx_runtime_1.jsx)(icons_1.AppIcon, { name: iconName, filllevel: fillLevel, color: disabled && disabledFillOverride
                    ? disabledFillOverride
                    : disabled
                        ? theme.colors.grey30
                        : color, slashcolor: slashcolor, size: size, iconSize: iconSize })] })));
};
exports.IconButton = IconButton;
//# sourceMappingURL=icon_button.js.map